import { MediaCarousel } from 'marketplace-ui-details/media/MediaCarousel';
import { useMemo } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export function AssetMediaCarousel({
  screenshots,
  videoUrl,
  onTrackInteraction
}) {
  const mediaCarouselItems = useMemo(() => {
    const carouselItems = screenshots.map(s => ({
      type: 'image',
      source: s.imageUrl,
      alt: s.altText ? s.altText : ''
    }));
    if (videoUrl) {
      carouselItems.unshift({
        type: 'video',
        source: videoUrl,
        alt: ''
      });
    }
    return carouselItems;
  }, [screenshots, videoUrl]);
  return /*#__PURE__*/_jsx(MediaCarousel, {
    items: mediaCarouselItems,
    onTrackInteraction: onTrackInteraction
  });
}